import React, { Component } from 'react';
import { connect } from 'react-redux';
import deep from 'deep-diff';
import AvaJsonTreeview from '../documentViewers/json/AvaJsonTreeview';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import JSON_TRANSFORM from '../../utils/jsonTransform/jsonTransformers';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import _ from "underscore";
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const FORM_NAME = 'TRANSACTION_EDIT_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

class TransactionEditForm extends Component {
  constructor(props) {
    super(props);
    this.state = { reason: '', reasonError: false };
  }
  onChange(fieldName, evt) {
    const newState = { [fieldName]: evt.target.value };
    if (fieldName === 'reason') {
      newState.reasonError = false;
    }
    this.setState(newState);
  }
  render() {
    log.debug('render(): ', this.props);

    const jsonViewerValues = this.props.formData && this.props.formData.structured.documentJson.ReportingDocument;
    let actionLabel = 'editTransaction_' + this.props.action;
    const isForceToError = this.props.action === 'forceToError';

    if (!jsonViewerValues) {
      return (<div><LanguageStringResolver string='editTransaction_noData' /></div>);
    }

    return (
      <ReadOnlyWrapper>
        <div>
          <div className="invoice-container">
            <h2><LanguageStringResolver string="editTransaction_action" /> <LanguageStringResolver string={actionLabel} /></h2>
            <div className="flex-box-container relative z-index-1">
              <div className="clear"></div>
              <fieldset>
                <s-row>
                  <s-col span="2">
                    <label className="mt20"><LanguageStringResolver string="editTransaction_transactionData" /></label>
                  </s-col>
                  <s-col span="10">
                    <AvaJsonTreeview
                      src={jsonViewerValues}
                      collapsed={true}
                      onEdit={
                        e => { this.handleReportingDocumentChange(e) }
                      }
                    />
                  </s-col>
                </s-row>
                <hr className="mt10 mr0 mb10 ml0" />
                <s-row>
                  <s-col span="2">
                    <label className="mt15 mb15" htmlFor="transaction-edit-reason">
                      <LanguageStringResolver string="editTransaction_reason" />
                      {isForceToError ? <span aria-hidden="true"> *</span> : null}
                    </label>
                  </s-col>
                  <s-col span="10">
                    <input
                      id="transaction-edit-reason"
                      type="text"
                      className={'mt10 mb15' + (this.state.reasonError ? ' invalid' : '')}
                      value={this.state.reason}
                      onChange={this.onChange.bind(this, 'reason')}
                      aria-required={isForceToError}
                      aria-invalid={this.state.reasonError}
                      aria-describedby={this.state.reasonError ? 'transaction-edit-reason-error' : undefined}
                    />
                    {this.state.reasonError ? (
                      <div id="transaction-edit-reason-error" className="mt0 mb15" style={{ color: 'var(--color-red-medium)' }} role="alert">
                        <LanguageStringResolver string="editTransaction_reasonRequired" />
                      </div>
                    ) : null}
                  </s-col>
                </s-row>
                <hr className="mt10 mr0 mb10 ml0" />
              </fieldset>
            </div>
          </div>
          <div>
            <button className="primary mt15 mb20" onClick={this.onSubmitForm.bind(this)}><LanguageStringResolver string={actionLabel} /></button>
            <button className="secondary mt15 mb20" onClick={this.onResetForm.bind(this)}><LanguageStringResolver string="editTransaction_reset" /></button>
          </div>
        </div>
      </ReadOnlyWrapper>
    );
  }

  componentWillUnmount() {
    log.debug('componentWillUnMount: ', FORM_NAME);
    this.props.doDestroyForm(FORM_NAME);
  }

  componentDidUpdate(prevProps) {
    log.debug('componentDidUpdate(): ');
    if (this.props.transaction !== prevProps.transaction) {
      this.props.doInitialiseForm(this.props.transaction);
      this.props.doAddStructuredObject(this.props.transaction);
    }
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    this.props.doInitialiseForm(this.props.transaction);
    this.props.doAddStructuredObject(this.props.transaction);
  }

  handleReportingDocumentChange(data) {
    log.debug('handleReportingDocumentChange: ', data);
    const diff = deep(data.existing_src, data.updated_src);
    let value = diff[0].rhs;
    let key = 'documentJson.ReportingDocument.';
    key += JSON_TRANSFORM.arrayToFlatReference(diff[0].path);

    // SVR-840 Make values not editable in treeview to match main ux
    // the change is reset back to the old value 'lhs' before doing the update
    // list can be extended if needed
    if (_.contains(['IVATUUID', 'ConnectorVersion', 'ConnectorName'], data.name)) {
      value = diff[0].lhs;
    }

    this.doFieldChange(key, value);
    log.debug('handleReportingDocumentChange: ', diff);
  }

  doFieldChange(key, value) {
    log.debug('doFieldChange: key: %s value: ', key, value);
    this.props.onFieldChange(key, value);
    this.props.onStructuredFieldChange(key, value);
  }

  onSubmitForm() {
    log.debug('onSubmitForm(): ', this.props.formData);
    const trimmedReason = (this.state.reason || '').trim();
    if (this.props.action === 'forceToError' && trimmedReason === '') {
      this.setState({ reasonError: true });
      return;
    }
    // use the handler passed in from the page and pass it this formData
    this.props.submitHandler(this.props.formData, trimmedReason);

    // Let the forms controller know that the form has been submitted.
    this.props.doFormSubmitted(FORM_NAME);
  }

  onResetForm() {
    log.debug('onResetForm(): ');
    this.setState({ reason: '', reasonError: false });
    this.props.doResetForm(FORM_NAME);
    this.props.doAddStructuredObject(this.props.transaction);
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);

  return {
    formData: (state.managedUxForms && state.managedUxForms.forms[FORM_NAME]),
  };
}


function mapDispatchersToProps(dispatch) {
  return {
    // Standard form actions
    doInitialiseForm: (initialValues) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(FORM_NAME, JSON_TRANSFORM.flattenJSON(initialValues)));
    },
    doAddStructuredObject: (structured) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doAddStructuredObject(FORM_NAME, structured));
    },
    doResetForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(FORM_NAME));
    },
    doClearForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(FORM_NAME));
    },
    onFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(FORM_NAME, fieldName, value));
    },
    onStructuredFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doStructuredFieldChange(FORM_NAME, fieldName, value));
    },
    doFormSubmitted: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(FORM_NAME));
    },
    doDestroyForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(FORM_NAME));
    }
    //TODO: Add dispatchers (actions we expect controllers to perform) here.
  }
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(TransactionEditForm);
